// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"62":"f70c95cf","114":"7c0ed760","230":"90d7d557","578":"7419205b","629":"4db4193a","912":"ed082382"}[chunkId] + ".chunk.css";
};